import type { Reference, ResourceType } from "@medplum/fhirtypes";

export function domainIdFromReference(system: string, reference: Reference | undefined): string | undefined {
  return reference?.identifier?.system === system ? reference.identifier.value : undefined;
}
export interface ReferenceWriter {
  identity(type: ResourceType, system: string, value: string): Reference<never>;
  memberType(type: ResourceType, system: string, value: string): Reference<never>;
}
const logical = (_type: ResourceType, system: string, value: string): Reference<never> => ({
  identifier: { system, value },
});
export const logicalReferences: ReferenceWriter = { identity: logical, memberType: logical };
